import { buildComponent } from '#components'
import { z } from 'zod'
import ColorGroupSwatchesVue from './ColorGroupSwatches.vue'

import './color-group-swatches.css'

const ColorGroupSwatchesPropsSchema = z
  .object({
    product: z.object({
      handle: z.string(),
      tags: z.array(z.string())
    }),
    allowSingleSwatch: z.boolean(),
    pdpNavigate: z.boolean(),
    triggerRequired: z.boolean(),
    wrapperType: z.string()
  })
  .partial({
    allowSingleSwatch: true,
    pdpNavigate: true,
    triggerRequired: true,
    wrapperType: true
  })

export type ColorGroupSwatchesProps = z.infer<typeof ColorGroupSwatchesPropsSchema>

const ColorGroupSwatches = buildComponent({
  name: 'color-group-swatches',
  propsSchema: ColorGroupSwatchesPropsSchema,
  vueComponent: ColorGroupSwatchesVue
}) as ReturnType<typeof buildComponent>

declare global {
  interface HTMLElementTagNameMap {
    'color-group-swatches': typeof ColorGroupSwatches
  }
}
